
import { GetHeaderMenuByUserResponse } from '@/api/dtos';
import IsLoading from '@/components/layouts/IsLoading';
import HeaderMenuContext from '@/contexts/data/HeaderMenuContext';
import useHeaderMenuByUser from '@/hooks/data/useHeaderMenuByUser';
import { FC, PropsWithChildren } from 'react';


export interface IHeaderMenuProviderProps {
    initial?: GetHeaderMenuByUserResponse;
}

export const HeaderMenuProvider: FC<PropsWithChildren<IHeaderMenuProviderProps>> = ({ initial, children }) => {
    const headerMenu = useHeaderMenuByUser({ revalidateOnFocus: false, fallbackData: initial});

    return (
        <HeaderMenuContext.Provider value={headerMenu}>
            <IsLoading name="headerMenu" loading={headerMenu.loading} validating={headerMenu.validating}/>
            {children}
        </HeaderMenuContext.Provider>
    );
}

export default HeaderMenuProvider;
